import type { IUseCase } from '@/shared/contracts/use-case.contract';
import {
  ENDPOINT,
  type EditUserAddressRequest,
  type EditUserAddressResponse,
} from '../../types/edit-user-address';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

export type UseCaseInput = {
  address_id: string;
  data: EditUserAddressRequest;
};

type UseCaseOutput = EditUserAddressResponse;

export class EditUserAddressUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { address_id, data } = input;

    if (!address_id || !data) {
      throw new Error('User address id and data are required');
    }

    const response = await this.client.sendRequest<EditUserAddressResponse, EditUserAddressRequest>(
      {
        method: HttpMethod.PUT,
        endpoint: ENDPOINT(address_id),
        body: {
          ...data,
        },
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }
    );

    return response;
  }
}
